import Box from '@mui/material/Box';
import { DesktopDatePicker } from '@mui/x-date-pickers'
import MenuPopover from '../MenuPopover.js'
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default function DateRange(props) {
  return (
    <MenuPopover 
        changed={props.changed} 
        closeIcon={props.closeIcon}
        title="Date range"
        marginThreshold ={100000}
      >
      <Box sx={{ margin: 4, width: 250 }}>
        <Stack spacing={3}>
          {props.message &&
            <Typography>{props.message}</Typography>
          }
          <DesktopDatePicker
            label="Start"
            inputFormat="YYYY-MM-DD"
            value={props.startDate}
            onChange={props.startDateChanged}
            renderInput={(params) => <TextField {...params} />}
          />
          <DesktopDatePicker
            label="End"
            inputFormat="YYYY-MM-DD"
            value={props.endDate}
            onChange={props.endDateChanged}
            renderInput={(params) => <TextField {...params} />}
          />
        </Stack>
      </Box>
    </MenuPopover>
  )
}

DateRange.propTypes = {
  changed: PropTypes.bool,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  startDateChanged: PropTypes.func,
  endDateChanged: PropTypes.func,
};
